// client-web-appsuite/src/constants/version.js

const VERSION = 10

export default VERSION